// The current state of every calendar_event element, mirrored into its own
// queryable table. Two elements with the same event_id in one thread describe the
// same event; the occurrence with the higher sequence replaces the older one
// wholesale, and a lower one never overwrites — pages replayed during a resync
// must not roll an event back.

import type { ImpEvent } from '$lib/protocol/types';

import { db } from './db';

/** Call inside the same transaction that writes the events. */
export async function applyCalendarEvents(accountId: string, events: ImpEvent[]): Promise<void> {
  for (const event of events) {
    const rawList = Array.isArray(event.rawElements) ? (event.rawElements as unknown[]) : [];
    for (let i = 0; i < event.elements.length; i++) {
      const element = event.elements[i]!;
      if (element.type !== 'calendar_event') {
        continue;
      }
      const id = `${accountId}/${element.eventId}`;
      const existing = await db.calendarEntries.get(id);
      if (existing !== undefined && existing.sourceSequence > event.sequence) {
        continue;
      }
      await db.calendarEntries.put({
        id,
        accountId,
        eventId: element.eventId,
        sourceSequence: event.sequence,
        elementJson: JSON.stringify(rawList[i] ?? {}),
      });
    }
  }
}
